// Stable harness slots that product routes can fill without remounting AppShell.
// The shell owns the geometry; the active product owns only the slot content.
export const PRODUCT_SIDEBAR_SLOT_ID = "app-product-sidebar";
